import React from "react";
import { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row, Card, Alert } from "react-bootstrap";

import PortalService from '../../../services/portal.service';
import StateContext from '../../../context/State';
import AddCustomFieldModal from "./AddCustomFieldModal";

import type { CustomField } from "../../../types";

const CustomFields = ({ displayMode = "full", editMode = false, name = '',  }) => {
    const { state } = useContext(StateContext);
    const portalService = new PortalService(state);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [customFields, setCustomFields] = useState<any>([]);

    useEffect(() => {
        // adding delay to account for potential empty array
        const timeout = setTimeout(() => {
            getCustomFieldsData();
        }, 2000)

        return () => clearTimeout(timeout)
    }, []);

    const getCustomFieldsData = async () => {
        const response: CustomField = await portalService.getClientPortalCustomFields(state.portalId);
        setCustomFields(response);
    }

    const filteredFields = editMode ? customFields.filter(field => field.PerClient === false) : customFields.filter(field => field.PerClient === true);

    if (displayMode === "simple") {
        return (
            <>
                    {filteredFields.map((field, index) => {
                        const identifier = field.Identifier;
                        const identifierObject = JSON.parse(identifier);
                        const value = identifierObject[name];
                        return (
                            <Col className="col-4 mb-3" key={field.Name + '-custom-field-' + index}>
                                <React.Fragment>
                                    <Form.Label>{field.Name}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        readOnly={true}
                                        value={value}
                                        placeholder={value || 'Not Submitted'}
                                    />
                                </React.Fragment>
                            </Col>
                        );
                    })}
            </>
        );
    }

    return (
        <Card >
            <Card.Header>
                <Card.Title>Custom Fields</Card.Title>
            </Card.Header>

            <Card.Body>
                <Row >
                    {filteredFields.map((field, index) => {
                        const value = field.Value ?? undefined;
                        return (
                            <Col className="col-4 mb-3" key={field.Name + '-custom-field-' + index}>
                                <React.Fragment>
                                    <Form.Label>{field.Name}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        readOnly={true}
                                        value={value}
                                        placeholder={value || 'Not Submitted'}
                                    />
                                </React.Fragment>
                            </Col>
                        );
                    })}
                </Row>
                {customFields.length === 0 && <Alert>No custom fields added. Please click 'Add Custom Fields' below to get started.</Alert>}
                    <br />
                <Row>
                    <Col>
                        <Button onClick={() => setShowModal(true)}>
                            {customFields.length === 0 ? 'Add' : 'Edit'} Custom Fields
                        </Button>
                        <AddCustomFieldModal
                            getCustomFieldsData={getCustomFieldsData}
                            showModal={showModal}
                            onHideModal={() => {
                                getCustomFieldsData()
                                setShowModal(false)
                            }}
                        />
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}

export default CustomFields;
